'use client';

import type { TranslationSnapshotBoundaryComponent } from '@eliadmin/core/src/i18n/translation-snapshot-types';
import dynamic from 'next/dynamic';

const DictionaryBoundary0 = dynamic(() => import('./providers/dictionary-89b12f6345b52d31f086bfa12a9380e4df9bd3a4403770156858718b365f8085'));
const DictionaryBoundary1 = dynamic(() => import('./providers/dictionary-a62c2d3691974441a9f8493e7dd64fccbc07508ce33b70b0580eb7692fe86da3'));

export const GENERATED_TRANSLATION_BOUNDARIES: Readonly<Record<string, TranslationSnapshotBoundaryComponent>> = {
  "sk": DictionaryBoundary0,
  "en": DictionaryBoundary1,
};
